import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useTheme from '../hooks/useTheme';

const ThemeProvider = ({ children }) => {
  const { applyTheme } = useTheme();
  
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin || {};

  useEffect(() => {
    // If we have full hospital info in Redux (e.g., right after login)
    if (userInfo?.hospital?.primary_color) {
      applyTheme({
        primary_color: userInfo.hospital.primary_color,
        secondary_color: userInfo.hospital.secondary_color,
        opaque_color: userInfo.hospital.opaque_color,
      });
      return;
    }

    // Fallback to localStorage (e.g., on hard refresh where userInfo.hospital might not be fully populated)
    const safeParse = (val) => {
      if (!val) return val;
      try {
        const parsed = JSON.parse(val);
        return parsed;
      } catch (e) {
        return val;
      }
    };

    const storedPrimary = safeParse(localStorage.getItem('hospital_primary_color'));
    const storedSecondary = safeParse(localStorage.getItem('hospital_secondary_color'));
    const storedOpaque = safeParse(localStorage.getItem('hospital_opaque_color'));

    if (storedPrimary || storedSecondary || storedOpaque) {
      applyTheme({
        primary_color: storedPrimary,
        secondary_color: storedSecondary,
        opaque_color: storedOpaque,
      });
    } else {
      applyTheme(null);
    }
  }, [userInfo, applyTheme]);

  return <>{children}</>;
};

export default ThemeProvider;
